import { useState } from "react";
import { Box, Button, Dialog, DialogContent } from "@mui/material";
import Slider from "react-slick";
import PropTypes from "prop-types";
import Navbar from "../layout/Navbar";
import Footer from "../layout/Footer";
import { NextArrow, PrevArrow } from "../components/sliderArrow";
import styles from "./page.module.sass";

function NewsNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", marginRight: "-100px" }}
      onClick={onClick}
    />
  );
}

NewsNextArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

function NewsPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div
      className={className}
      style={{ ...style, display: "block", marginLeft: "-100px" }}
      onClick={onClick}
    />
  );
}

NewsPrevArrow.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  onClick: PropTypes.func,
};

function Branch1() {
  const [nav1, setNav1] = useState();
  const [nav2, setNav2] = useState();
  const [open, setOpen] = useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };
  return (
    <>
      <Navbar />
      <main>
        <section className="h-[250px] m-auto pt-[64px] taichung-title">
          <div className="text-center mb-[44px]"></div>
        </section>
        <section className="max-w-[1300px] m-auto" style={{ marginBottom: "100px" }}>
          <Box className="flex my-[10px] md-l:mx-10">
            <Box className="pr-[60px] pt-[60px] pb-[20px] md-l:pr-0" width="50%">
              <iframe
                title="branchMap"
                className="photo-like md-l:w-full"
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d455.06072264290196!2d120.67706425029716!3d24.154690449936307!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x34693d64d0cf756b%3A0xa621738e32436e8!2z5a6J5L-h5ZyL6Zqb6LOH55Si566h55CG6aGn5ZWP6IKh5Lu95pyJ6ZmQ5YWs5Y-4!5e0!3m2!1szh-TW!2stw!4v1701896554839!5m2!1szh-TW!2stw"
                width="688"
                height="370"
                allowfullscreen=""
                loading="lazy"
                referrerPolicy="no-referrer-when-downgrade"
                style={{ marginTop: "30px" }}
              ></iframe>
            </Box>
            <Box className="pl-[90px] pt-[150px] pb-[20px] md-l:pl-[30px]" width="50%">
              <p
                className="pb-[10px]"
                style={{ fontSize: "20px", color: "#696969", fontWeight: 400 }}
              >
                電話：(04)2202-8800
              </p>
              <p
                className="pb-[150px]"
                style={{ fontSize: "20px", color: "#696969", fontWeight: 400 }}
              >
                住址：台中市北區中清路一段79號10樓（附有充電樁）
              </p>
              <Button
                sx={{
                  backgroundColor: "#FFCC06",
                  color: "black",
                  fontWeight: 400,
                  width: "100px",
                  "&:hover": { backgroundColor: "darkorange" },
                }}
                onClick={handleOpen}
              >
                停車資訊
              </Button>
            </Box>
          </Box>
          <Dialog open={open} onClose={handleClose}>
            <DialogContent>
              <img src="/branch-1-park.jpg" alt="停車資訊" style={{ width: "100%" }} />
            </DialogContent>
          </Dialog>
        </section>
        <section className="bg-yellow-noh mt-[-150px]"></section>
        <div className="text-center mb-[40px] mt-[-940px]">
          <h2 className="text-[#3D3D3D] font-normal text-5xl mb-[15px]">環境照片</h2>
          <h3 className="text-[#696969] font-normal text-xl">Office environment photos</h3>
        </div>
        <Box sx={{ margin: "0 auto" }}>
          <div className="w-[50%] shadow-xl" style={{ margin: "0 auto", marginBottom: "50px" }}>
            <Slider
              asNavFor={nav2}
              focusOnSelect={false}
              ref={(slider) => setNav1(slider)}
              className="m-auto"
              fade={true}
              prevArrow={<PrevArrow customClassName={styles.prevArrow} />}
              nextArrow={<NextArrow customClassName={styles.nextArrow} />}
            >
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/DiSGFHcvryBxfLtK4Sifvq.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/FXC4S5GwrBRxB9eorZY3qx.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/VEnrLteMyVDrM2UXpcW8nV.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/KkJZ3dUSj3uo4yMzrLtVQ7.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/beLwku5BYntuPi7zf2KC9r.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/jKMX4XDfgf7RK7aWp7Khgq.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/BCRHnp4xDS2chZScGRJe4e.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/jLNDtmqULCrSsfG7gsg8YE.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/YEM4dJwMmGJ9NBF5KscXJE.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/Q9XQ6TQN4Sz4z9Kibcb5Uz.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/hNYAeHT9ZyvFHttd34Pz3n.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/GbkQAcKLcGqom3B3EKXcRk.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/4LsXM2ULsuYy6vQLje9dot.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/gz42nXPUUFFuHYN9qGT4Vt.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/5SsKhdNouYLwib3GSNrK9n.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/K57mvdJ6Ec4sAFZ2JjNsUq.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/Bn9Jtx2YWR5Wp9nn62MzxC.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/LFpXohoicetUw9NPh5gz8V.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/h3geAUuKNpCZgGJ7SzyXMJ.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/AGAAKvVDFFwvLcDxWU5E8a.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/YL4KF8jTZvrDPukAJgpgjG.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/DPh4Fm2YuZHkPZVTwtdknE.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/i7sToDSkrYVKsKTrMbhSWz.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/cBrvKxxh26ruWqDxS2btLb.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/izsNqXDA995F7AoNcBFfv3.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/FMkMcPuTmkP8jn6KGtNzY5.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/XrPid2sTWAZ8QEJURHvz7U.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/aeH4AQ4FVsvHxjnCSUj7Ci.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/SDTpmVzXGEGJXBWkrBFWFD.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/js39WTaxY5Zb5rYeNZrHU2.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/YkazbMCUUMfw7TXwB3tJVD.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/bJBqU5FoFxVJnBPbKX46HQ.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/avoyjP9zxdM9LsHKxdhRjy.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/J8GuLZ3cFsjiHQed5EaUFk.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/3QS6opRBayHA7K8piyt7kg.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/m9NcJgNn6VwxFPuykHodPa.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/b7rjzGu9Qh9jwnqH95tpPG.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/N62Wwh4eT5EgyXsrUUZsWv.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/hcFWVMdD95c7j9kr79fojj.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/LNtLnXtDLa4FhdsVJmKmUL.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/GXKHzBRDa34fSdbHEexBKr.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/ddvioTVaHCDwiUtAixvSpf.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/QQ8zCnJcw8FdMxNbmpQ29N.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/LqkFvh3hzsz55QcVWk5PPr.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/8oc3xYubzHviNNkvvckZyX.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/HqCCMQaXcEqBXga7pQsSJ9.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/QrxrcgFEkYvTF2TJxLuPFs.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/QiZrqHwgiNPtvN6E7AiSET.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/VqKtRaBMvdvSMD73GZBkV5.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/8PRhx7LxaAmnSW6wvpAvR8.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/oAj8FU9i2rVseguGfGKwXF.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/m7ixhK3m8MSvWgTmxi2hYs.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/nNCv4jrKor9QysGZEcJq7r.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/CBsUsuwxAAboMmNZovCUYH.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/YRdB3WKn9DKxz9iqZ8arCb.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/DN77EnBhpVejX9HHyvR8Zc.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/CGTxvXJot6pKrqk7uU328v.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/dKaX26GL2S3QxzrknZF34a.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/DPYMk9DqU5MPGGrFydf7AK.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/KLnmxxumGcctD2rW4eW2xb.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/GwQHwTgQedqUkCgmjGMjMD.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/oMrWtU8MEX9fT9S6Vs6MwL.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/57FYt4xV5TckG5U2uWVrsm.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/62sFQYDNkHa9YJSQ5Fci6X.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/deCJSeoahzRrgf2WmzNbCC.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/forgU4PyWEUgtLMR8XiUYq.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/iSv5F7RVbgLd4k3tzmtJEa.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/4yRaVHMdWrBy5PMiqsUyz2.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/nNBDDkrrM4jrRRn8GgRa2t.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/agdneaddDYuazn6hVe2fEP.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/kqjVrzzgnvAUScwTyhKn6D.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/46sMZZr8AmEVCBn68YVd7X.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/G9xtivjfdQGEXF4ooaBLtp.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/E74VUrimcApzVw2ZiDDBoA.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/TdQF9zCrUnxwQCzfV95Eqw.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/dcXuJ8G7XjYxPVoscb4Eww.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/P7A6wyuKPZrj3e4PePoCUS.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/ntY9aRMch7DngaqfYWQicH.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/iyxw5RDT2rGBjY4XoHN8of.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/ZjHteCkpzgAJuK5jkAbTsX.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/TzdeQp4NbtNd8eHHeGxmsY.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/KDTPu2zoyPoTA4EBJqS6mU.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/MDpg2yLEpGuKxoaUoX3vj5.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/HQ6BazKAKBhFr7kythZzWG.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/FwvMczgdHnbB2fWzar4GxC.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/oEivMT3z7ycC7ZkqJnQ4qL.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/4REgFqse8JZYYMpe2kHrEw.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/Edxo3k83V4pawtJKtQMPJ7.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/RGDH7fRJFdPFADxKo5HTiA.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/JNJgkbZiGi9YWPNaBbWswV.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/jr5SqiQayAfPHxyEiwNFSD.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/QQQnVC2iH5gDe5FJBxXQwZ.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/4GJiGyjvGxafkoDi3HaHLh.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/8TahyWNRcX8PnYQjvL5rmn.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/aCJAqA2jc5iEn8JfjBLBCL.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/UKTtLHLSegKEDUVn6gGjYd.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/HhgtKWJQTgLidsbYTMAbZW.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/jrsPXwNNcpiWzi4GsSJY6s.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/EDMFPTA8BwLEwzL85drjHv.jpg"
                  alt=""
                />
              </div>
              <div>
                <img
                  className="photo-like-nos"
                  src="http://cdn.asiamc.com.tw/XGzzSDg3waiKXW8rRe6GVi.jpg"
                  alt=""
                />
              </div>
            </Slider>
          </div>
          <div style={{ margin: "0 auto", marginBottom: "50px" }}>
            <Slider
              asNavFor={nav1}
              ref={(slider) => setNav2(slider)}
              slidesToShow={3}
              swipeToSlide={true}
              focusOnSelect={true}
              infinite={true}
              className={"center photo-like-nos"}
              centerMode={true}
              prevArrow={<PrevArrow customClassName={styles.prevArrow} />}
              nextArrow={<NextArrow customClassName={styles.nextArrow} />}
              variableWidth={true}
            >
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/DiSGFHcvryBxfLtK4Sifvq.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/FXC4S5GwrBRxB9eorZY3qx.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/VEnrLteMyVDrM2UXpcW8nV.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/KkJZ3dUSj3uo4yMzrLtVQ7.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/beLwku5BYntuPi7zf2KC9r.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/jKMX4XDfgf7RK7aWp7Khgq.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/BCRHnp4xDS2chZScGRJe4e.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/jLNDtmqULCrSsfG7gsg8YE.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/YEM4dJwMmGJ9NBF5KscXJE.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/Q9XQ6TQN4Sz4z9Kibcb5Uz.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/hNYAeHT9ZyvFHttd34Pz3n.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/GbkQAcKLcGqom3B3EKXcRk.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/4LsXM2ULsuYy6vQLje9dot.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/gz42nXPUUFFuHYN9qGT4Vt.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/5SsKhdNouYLwib3GSNrK9n.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/K57mvdJ6Ec4sAFZ2JjNsUq.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/Bn9Jtx2YWR5Wp9nn62MzxC.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/LFpXohoicetUw9NPh5gz8V.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/h3geAUuKNpCZgGJ7SzyXMJ.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/AGAAKvVDFFwvLcDxWU5E8a.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/YL4KF8jTZvrDPukAJgpgjG.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/DPh4Fm2YuZHkPZVTwtdknE.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/i7sToDSkrYVKsKTrMbhSWz.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/cBrvKxxh26ruWqDxS2btLb.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/izsNqXDA995F7AoNcBFfv3.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/FMkMcPuTmkP8jn6KGtNzY5.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/XrPid2sTWAZ8QEJURHvz7U.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/aeH4AQ4FVsvHxjnCSUj7Ci.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/SDTpmVzXGEGJXBWkrBFWFD.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/js39WTaxY5Zb5rYeNZrHU2.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/YkazbMCUUMfw7TXwB3tJVD.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/bJBqU5FoFxVJnBPbKX46HQ.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/avoyjP9zxdM9LsHKxdhRjy.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/J8GuLZ3cFsjiHQed5EaUFk.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/3QS6opRBayHA7K8piyt7kg.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/m9NcJgNn6VwxFPuykHodPa.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/b7rjzGu9Qh9jwnqH95tpPG.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/N62Wwh4eT5EgyXsrUUZsWv.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/hcFWVMdD95c7j9kr79fojj.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/LNtLnXtDLa4FhdsVJmKmUL.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/GXKHzBRDa34fSdbHEexBKr.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/ddvioTVaHCDwiUtAixvSpf.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/QQ8zCnJcw8FdMxNbmpQ29N.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/LqkFvh3hzsz55QcVWk5PPr.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/8oc3xYubzHviNNkvvckZyX.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/HqCCMQaXcEqBXga7pQsSJ9.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/QrxrcgFEkYvTF2TJxLuPFs.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/QiZrqHwgiNPtvN6E7AiSET.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/VqKtRaBMvdvSMD73GZBkV5.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/8PRhx7LxaAmnSW6wvpAvR8.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/oAj8FU9i2rVseguGfGKwXF.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/m7ixhK3m8MSvWgTmxi2hYs.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/nNCv4jrKor9QysGZEcJq7r.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/CBsUsuwxAAboMmNZovCUYH.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/YRdB3WKn9DKxz9iqZ8arCb.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/DN77EnBhpVejX9HHyvR8Zc.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/CGTxvXJot6pKrqk7uU328v.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/dKaX26GL2S3QxzrknZF34a.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/DPYMk9DqU5MPGGrFydf7AK.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/KLnmxxumGcctD2rW4eW2xb.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/GwQHwTgQedqUkCgmjGMjMD.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/oMrWtU8MEX9fT9S6Vs6MwL.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/57FYt4xV5TckG5U2uWVrsm.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/62sFQYDNkHa9YJSQ5Fci6X.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/deCJSeoahzRrgf2WmzNbCC.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/forgU4PyWEUgtLMR8XiUYq.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/iSv5F7RVbgLd4k3tzmtJEa.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/4yRaVHMdWrBy5PMiqsUyz2.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/nNBDDkrrM4jrRRn8GgRa2t.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/agdneaddDYuazn6hVe2fEP.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/kqjVrzzgnvAUScwTyhKn6D.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/46sMZZr8AmEVCBn68YVd7X.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/G9xtivjfdQGEXF4ooaBLtp.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/E74VUrimcApzVw2ZiDDBoA.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/TdQF9zCrUnxwQCzfV95Eqw.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/dcXuJ8G7XjYxPVoscb4Eww.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/P7A6wyuKPZrj3e4PePoCUS.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/ntY9aRMch7DngaqfYWQicH.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/iyxw5RDT2rGBjY4XoHN8of.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/ZjHteCkpzgAJuK5jkAbTsX.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/TzdeQp4NbtNd8eHHeGxmsY.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/KDTPu2zoyPoTA4EBJqS6mU.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/MDpg2yLEpGuKxoaUoX3vj5.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/HQ6BazKAKBhFr7kythZzWG.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/FwvMczgdHnbB2fWzar4GxC.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/oEivMT3z7ycC7ZkqJnQ4qL.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/4REgFqse8JZYYMpe2kHrEw.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/Edxo3k83V4pawtJKtQMPJ7.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/RGDH7fRJFdPFADxKo5HTiA.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/JNJgkbZiGi9YWPNaBbWswV.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/jr5SqiQayAfPHxyEiwNFSD.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/QQQnVC2iH5gDe5FJBxXQwZ.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/4GJiGyjvGxafkoDi3HaHLh.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/8TahyWNRcX8PnYQjvL5rmn.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/aCJAqA2jc5iEn8JfjBLBCL.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/UKTtLHLSegKEDUVn6gGjYd.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/HhgtKWJQTgLidsbYTMAbZW.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/jrsPXwNNcpiWzi4GsSJY6s.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/EDMFPTA8BwLEwzL85drjHv.jpg"
                  alt="slick-list"
                />
              </div>
              <div>
                <img
                  className="slick-image-list"
                  src="http://cdn.asiamc.com.tw/XGzzSDg3waiKXW8rRe6GVi.jpg"
                  alt="slick-list"
                />
              </div>
            </Slider>
          </div>
        </Box>
      </main>
      <Footer />
    </>
  );
}

export default Branch1;
